<template>
  <ol v-if="$page.props.breadcrumbs?.length" class="breadcrumb">
    <template v-for="(breadcrumb, key, index) in $page.props.breadcrumbs" :key="key">
      <li class="breadcrumb-item" :class="index === $page.props.breadcrumbs.length - 1 ? 'active' : ''">
        <Link v-if="breadcrumb.url" :href="breadcrumb.url">{{ breadcrumb.title }}</Link>
        <template v-else>{{ breadcrumb.title }}</template>
      </li>
    </template>
  </ol>
</template>

<script>
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    Link,
  },
}
</script>